/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Pxk_For_Scenting_Single_Lot_HintInputs */

const vi_sl_pxk_for_scenting_single_lot_hint = /** @type {(inputs: Sl_Pxk_For_Scenting_Single_Lot_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do 'Để lấy hương' chỉ cho chọn 1 lô. Nếu cần xuất nhiều lô đi lấy hương, tạo nhiều phiếu xuất riêng.`)
};

/**

* @param {Sl_Pxk_For_Scenting_Single_Lot_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pxk_for_scenting_single_lot_hint = /** @type {((inputs?: Sl_Pxk_For_Scenting_Single_Lot_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pxk_For_Scenting_Single_Lot_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pxk_for_scenting_single_lot_hint(inputs)
});